module.exports = __webpack_public_path__ + "assets/img/pointeroffline.d977b096.png";